// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.forgotdiv1{
    border: 2px solid #00000017 !important;
    padding: 15px !important;
    border-radius: 5px !important;
    margin-top: 9rem !important;
    -webkit-backdrop-filter: blur(20px) !important;
            backdrop-filter: blur(20px) !important;
    opacity: 1.9 !important;
    align-items: center !important;
    height: 80% !important;
    width: 100% !important;
 
}
.LogoDivchange{
    display: flex;
    justify-content: center !important;
}

.passInput{
    margin-top: 10px !important;
    background: #FFFFFF;
    border: 1px solid #CDCDCD;
    border-radius: 5px;
    height: 50px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Components/PasswordChange/PasswordChange.css"],"names":[],"mappings":";AACA;IACI,sCAAsC;IACtC,wBAAwB;IACxB,6BAA6B;IAC7B,2BAA2B;IAC3B,8CAAsC;YAAtC,sCAAsC;IACtC,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;;AAE1B;AACA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf","sourcesContent":["\r\n.forgotdiv1{\r\n    border: 2px solid #00000017 !important;\r\n    padding: 15px !important;\r\n    border-radius: 5px !important;\r\n    margin-top: 9rem !important;\r\n    backdrop-filter: blur(20px) !important;\r\n    opacity: 1.9 !important;\r\n    align-items: center !important;\r\n    height: 80% !important;\r\n    width: 100% !important;\r\n \r\n}\r\n.LogoDivchange{\r\n    display: flex;\r\n    justify-content: center !important;\r\n}\r\n\r\n.passInput{\r\n    margin-top: 10px !important;\r\n    background: #FFFFFF;\r\n    border: 1px solid #CDCDCD;\r\n    border-radius: 5px;\r\n    height: 50px;\r\n    width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
